<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-12-22 17:22:41
 * @FilePath: \mrc-base-frontend\src\views\app_version_manage\detail\index.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-12-23 12:38:58
-->
<template>
  <Info />
</template>

<script>
import Info from "../modules/info.vue";
export default {
  components: { Info },
  props: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  watch: {},
  computed: {},
  methods: {},
};
</script>

<style scoped></style>
